import { apiRequest } from './api';
import { CompanyHit } from '../pages/search/types';
import { ChunkType } from '../store/chat/types';

export interface SignalSearchRequest {
  query: string;
  companyIds?: string[];
  categories?: string[];
  types?: string[];
  minCalendarYear?: number;
  maxCalendarYear?: number;
}

export interface SignalSearchResponse {
  companies: CompanyHit[];
  totalCompanies: number;
}

export interface HydrateEmbeddingsRequest {
  embeddingIds: string[];
}

export interface HydratedSnippet {
  embeddingId: string;
  pageId: string;
  highlightText: string;
  blurb: string;
  chunk_type?: ChunkType;
}

// Document-level search
export interface DocumentSearchRequest {
  query: string;
  documentId: string;
  topK?: number;
  minSimilarity?: number;
}

export interface DocumentSearchHit {
  embeddingId: string;
  pageId: string;
  similarity: number;
  chunk_type?: ChunkType;
  highlightText?: string;
}

export interface DocumentSearchResponse {
  results: DocumentSearchHit[];
}

export const postSearch = async (payload: SignalSearchRequest): Promise<SignalSearchResponse> => {
  return apiRequest('/search', {
    method: 'POST',
    data: payload,
  });
};

export const postHydrateEmbeddings = async (
  payload: HydrateEmbeddingsRequest,
): Promise<HydratedSnippet[]> => {
  return apiRequest('/search/snippets', {
    method: 'POST',
    data: payload,
  });
};

export const postDocumentSearch = async (
  payload: DocumentSearchRequest,
): Promise<DocumentSearchResponse> => {
  return apiRequest('/search/document', {
    method: 'POST',
    data: payload,
  });
};
